<script>
  import { cloneArray } from 'components/Helper.js';

  import Select from 'svelte-select';
  export let groupUsers = [];
  import Loader from './../Loader.svelte';
  export let saveGroup = () => {};
  let readonly = false;
  let form = {
    id: '',
    userId: '',
    clientId: '',
    name: '',
    readonly: '',
    users: [],
  };
  export let comeFrom = '';
  const setData = () => {
    // if(comeFrom!='user'){
    //   form.id=""
    //   form.userId=""
    //   form.name=""
    //   form.readonly=""
    //   readonly=false
    //   form.users=groupUsers
    // }
  };
  let isFormPending = false;
  export const show = (allGroupUsers, data) => {
    groupUsers = cloneArray(
      allGroupUsers.map((item) => {
        item.id = item.userId;
        return item;
      }),
    );
    form = data;
    form.users = cloneArray(data.users);
    readonly = data.readonly == 1 ? true : false;
  };
  $: groupUsers && setData();
</script>

<!-- Modal -->
<div
  class="modal fade"
  id="creatGroupModal"
  tabindex="-1"
  aria-labelledby="creatGroupModal"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5
          class="modal-title font-size-14"
          id="exampleModalLabel"
        >
          {form.id > 0 ? 'Edit' : 'Create a'} Group
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        {#if isFormPending}
          <Loader />
        {:else}
          <div class="form-group mb-3">
            <div class="form-group mb-3">
              <label
                for=""
                class="form-label">Group Name</label
              >
              <input
                type="text"
                class="form-control"
                name="example-text-input"
                bind:value={form.name}
                placeholder="Enter Group Name"
              />
            </div>

            <div class="form-group mb-3">
              <label
                for=""
                class="form-label">Selected Users</label
              >

              <Select
                placeholder="Select Users"
                isClearable={false}
                isMulti={true}
                bind:selectedValue={form.users}
                on:select={(ev) => {
                  form.users = ev.detail;
                }}
                getSelectionLabel={(option) => {
                  return option.firstName + ' ' + option.lastName;
                }}
                optionIdentifier="userId"
                getOptionLabel={(option) => {
                  return option.firstName + ' ' + option.lastName;
                }}
                items={groupUsers}
              ></Select>
            </div>
            {#if form.userId > 0}
              <div class="checkbox c-checkbox">
                <label class="text-muted">
                  <input
                    type="checkbox"
                    name="readonly"
                    bind:checked={readonly}
                    on:change={(event) => {
                      form.readonly = event.target.checked ? 1 : 0;
                    }}
                  />
                  <span class="check-img" />
                  Prohibit Managers from editing group
                </label>
              </div>
            {/if}
          </div>
        {/if}
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="trans-btn my-0 mx-3 px-4 font-size-12 outline-0 btn-cancel font-size-12"
          data-bs-dismiss="modal">Cancel</button
        >
        <button
          type="button"
          on:click={() => {
            saveGroup(form);
          }}
          class="btn btn-primary m-0 px-4 font-size-12">{form.id > 0 ? 'Update' : 'Create'}</button
        >
      </div>
    </div>
  </div>
</div>
